.videoViewer {
  display: flex;
  max-height: 60vh;
  height: 60vh;

  &__container {
    width: 100%;
    height: 100%;
    flex-grow: 1;
    object-fit: contain;
    display: flex;
  }

  &__video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
